import { BUSCAR_BI_VENDEDOR, LIMPAR_BI_VENDEDOR } from '../../actions/types'

const itemInicial = {
    valorTotalFaturamento: '0',
    valorTotalCancelamento: '0',
    valorTotalLiquido: '0',
    valorTotalTicketMedio: '0',
    valorTotalDinheiro: '0',
    valorTotalCartao: '0',
    valorTotalComissao: '0',
    quantidadeFaturamento: 0,
    quantidadeCancelamento: 0,
    totalFaturamentoPorTrecho: [],
    totalFaturamentoPorVeiculo: [],
    totalFaturamentoPorFormaPagamento: [],
    totalFaturamentoPorTipoTarifa: [],
    totalFechamentoPorSituacao: [],
    totalBagagemPorAtivo: [],
    totalEncomendaPorSituacao: []
}

export default function reducerBIVendedor (state = itemInicial, action) {
    switch (action.type) {
        case BUSCAR_BI_VENDEDOR:
            return action.payload
        case LIMPAR_BI_VENDEDOR:
            return itemInicial
        default:
            return state
    }
}
